export default __webpack_public_path__ + "static/media/share-icon.5f0db4bb.svg";